var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYouxiang4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10l2 2m0 0l-2 2m2-2h-5",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2a1 1 0 00-1 1v10a1 1 0 001 1h6.5a.5.5 0 100-1H2V3.601l5.279 3.52a1.3 1.3 0 001.442 0l5.28-3.52L14 8.5a.5.5 0 001 0V3a1 1 0 00-1-1H2zm12 1zM13.1 3H2.9l4.933 3.288a.3.3 0 00.332 0L13.1 3z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_youxiang4.34126265.svg";
export { SvgTongyongYouxiang4 as ReactComponent };